export const MapiranjeDeljivihPravic = [
  {
    permissionId: 'EPOSLOVANJE',
    placeholder: 'Izberite naročnino',
    dataFeed: 'results',
    labelFeed: 'selector'
  },
  {
    permissionId: 'FIX_TELEFONIJA',
    placeholder: 'Izberite številko',
    dataFeed: 'results',
    labelFeed: 'results'
  },
  {
    permissionId: 'EMAIL',
    placeholder: 'Izberite elektronski predal',
    dataFeed: 'results',
    labelFeed: 'results'
  },
  {
    permissionId: 'NAROCNINE',
    placeholder: 'Izberite naročnino',
    dataFeed: 'selector',
    labelFeed: 'selector'
  },
  {
    permissionId: 'PRIKLJUCKI',
    placeholder: 'Izberite priključek',
    dataFeed: 'selector',
    labelFeed: 'selector'
  },
  {
    permissionId: 'RACUNI',
    placeholder: 'Izberite naročnino',
    dataFeed: 'selector',
    labelFeed: 'selector'
  },
  {
    permissionId: 'SMS_POSILJANJE',
    placeholder: 'Izberite številko',
    dataFeed: 'results',
    labelFeed: 'results'
  },
  {
    permissionId: 'TR_OPREMA',
    placeholder: 'Izberite opremo',
    dataFeed: 'selector',
    labelFeed: 'selector'
  },
  {
    permissionId: 'TV2GO',
    placeholder: 'Izberite priključek',
    dataFeed: 'selector',
    labelFeed: 'selector'
  },
  {
    permissionId: 'UMTS_TELEFONIJA',
    placeholder: 'Izberite številko',
    dataFeed: 'results',
    labelFeed: 'results'
  },
  {
    permissionId: 'NASTAVITVE_TELEFONIJA',
    placeholder: 'Izberite številko',
    dataFeed: 'results',
    labelFeed: 'results'
  },
  {
    permissionId: 'PORABA_TELEFONIJA',
    placeholder: 'Izberite številko',
    dataFeed: 'results',
    labelFeed: 'results'
  },
  {
    permissionId: 'OPEN_STACK_PROJECT_MAINTAINER',
    placeholder: 'Izberite priključek',
    dataFeed: 'results',
    labelFeed: 'results'
  },
  {
    permissionId: 'OPEN_STACK_PROJECT_USER',
    placeholder: 'Izberite priključek',
    dataFeed: 'results',
    labelFeed: 'results'
  }
]



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/Pravice/DeljenePravice/MapiranjeDeljivihPravic.js